import React, { PureComponent, createRef } from 'react';
import { TimelineMax } from "gsap";
import './CircularProgressBar.styles.scss';

class CircularProgressBar extends PureComponent {
    segment = createRef();
    percent = 0;
    timeline = new TimelineMax();

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.animate();
    }

    componentDidMount() {
        this.animate();
    }

    animate = () => {
        this.timeline.kill();
        const from = [this.percent];
        const to = [this.props.value];
        const ctx = this.segment.current.getContext('2d');
        const { size } = this.props;
        to.onUpdate = () => {
            this.percent = from[0];
            ctx.clearRect(0, 0, size, size);
            ctx.fillStyle = 'rgba(255, 255, 255, 0.17)';
            ctx.arc(size / 2, size / 2, size / 2, -Math.PI / 2, 3 * Math.PI / 2);
            ctx.fill();
            const gr = ctx.createLinearGradient(0, 0, size, size);
            gr.addColorStop(0, '#FB8C00');
            gr.addColorStop(1, '#7E57C2');
            ctx.fillStyle = gr;
            ctx.beginPath();
            ctx.moveTo(size / 2, size / 2);
            ctx.arc(size / 2, size / 2, size / 2, -Math.PI / 2, -Math.PI / 2 + (2 * Math.PI) * (this.percent / 100));
            ctx.moveTo(size / 2, size / 2);
            ctx.fill();
            ctx.closePath();
        };
        this.timeline.to(from, 0.8, to);
    };

    render() {
        return (
            <div className="CircularProgressBar" style={{
                width: this.props.size,
                height: this.props.size,
            }}>
                <canvas ref={this.segment} width={this.props.size} height={this.props.size}/>
                <div className={`CircularProgressBar__center ${this.props.isSmall ? 'CircularProgressBar__center--small' : ''}`}>
                    {this.props.value}%
                </div>
            </div>
        )
    }
}

export default CircularProgressBar;